import React, { useState, useContext } from 'react';
import * as S from './CreateClientModalStyle';
import { AuthContext } from '../../../Context/AuthContext';
import { FaBuilding, FaUniversity, FaUserPlus } from 'react-icons/fa';
import Loading from '../../Loader';

export default function CreateClientModal({ handleClose, onClientCreated }) {
    const { createClient } = useContext(AuthContext);

    const [formData, setFormData] = useState({
        name: '',
        cpfCnpj: '',
        email: '',
        password: '',
        phoneNumber: '',
        birthDate: '',
        jobTitle: '',
        username: '',
        consultorId: '',
        reinvest: false,
    });
    const [addressData, setAddressData] = useState({
        street: '', number: '', complement: '', neighborhood: '', city: '', zipcode: '', state: '', country: ''
    });
    const [bankData, setBankData] = useState({
        agencyNumber: '', pixKey: '', accountNumber: '', accountType: '', bank: '', beneficiary: ''
    });

    const [showBank, setShowBank] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    const handleChange = (e, setState) => {
        const { name, value, type, checked } = e.target;
        setState(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError('');
        setSuccess('');

        const payload = {
            ...formData,
            consultorId: formData.consultorId ? Number(formData.consultorId) : null,
            birthDate: formData.birthDate || null,
            address: addressData
        };

        if (showBank) {
            payload.bankAccount = bankData;
        } else {
            payload.bankAccount = null;
        }

        try {
            await createClient(payload);
            setSuccess('Cliente cadastrado com sucesso!');
            setTimeout(() => {
                onClientCreated();
            }, 1500);
        } catch (apiError) {
            setError(apiError.message || 'Ocorreu um erro. Verifique os dados e tente novamente.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <S.ModalBackdrop onClick={handleClose}>
            <S.ModalContent onClick={(e) => e.stopPropagation()}>
                <Loading load={isLoading} />
                <S.ModalHeader>
                    <h2><FaUserPlus /> Cadastrar Novo Cliente</h2>
                    <S.CloseButton onClick={handleClose}>&times;</S.CloseButton>
                </S.ModalHeader>
                <S.Form onSubmit={handleSubmit}>
                    <h4>Dados Pessoais e Acesso</h4>
                    <S.FormGrid>
                        <S.InputGroup>
                            <label>Nome Completo*</label>
                            <input name="name" value={formData.name} onChange={(e) => handleChange(e, setFormData)} required />
                        </S.InputGroup>
                        <S.InputGroup>
                            <label>CPF/CNPJ*</label>
                            <input name="cpfCnpj" value={formData.cpfCnpj} onChange={(e) => handleChange(e, setFormData)} required />
                        </S.InputGroup>
                        <S.InputGroup>
                            <label>E-mail*</label>
                            <input type="email" name="email" value={formData.email} onChange={(e) => handleChange(e, setFormData)} required />
                        </S.InputGroup>
                        <S.InputGroup>
                            <label>Senha* (mínimo 6 caracteres)</label>
                            <input type="password" name="password" value={formData.password} onChange={(e) => handleChange(e, setFormData)} required />
                        </S.InputGroup>
                        <S.InputGroup>
                            <label>Nome de Usuário</label>
                            <input name="username" value={formData.username} onChange={(e) => handleChange(e, setFormData)} />
                        </S.InputGroup>
                        <S.InputGroup>
                            <label>Celular</label>
                            <input name="phoneNumber" value={formData.phoneNumber} onChange={(e) => handleChange(e, setFormData)} />
                        </S.InputGroup>
                        <S.InputGroup>
                            <label>Data de Nascimento</label>
                            <input type="date" name="birthDate" value={formData.birthDate} onChange={(e) => handleChange(e, setFormData)} />
                        </S.InputGroup>
                         <S.InputGroup>
                            <label>Profissão</label>
                            <input name="jobTitle" value={formData.jobTitle} onChange={(e) => handleChange(e, setFormData)} />
                        </S.InputGroup>
                    </S.FormGrid>
                    
                    <>
                        <h4>Endereço*</h4>
                        <S.FormGrid>
                           <S.InputGroup>
                                <label>CEP*</label>
                                <input name="zipcode" value={addressData.zipcode} onChange={(e) => handleChange(e, setAddressData)} required />
                            </S.InputGroup>
                            <S.InputGroup className="full-width">
                                <label>Rua/Avenida*</label>
                                <input name="street" value={addressData.street} onChange={(e) => handleChange(e, setAddressData)} required />
                            </S.InputGroup>
                            <S.InputGroup>
                                <label>Número*</label>
                                <input name="number" value={addressData.number} onChange={(e) => handleChange(e, setAddressData)} required />
                            </S.InputGroup>
                             <S.InputGroup>
                                <label>Bairro*</label>
                                <input name="neighborhood" value={addressData.neighborhood} onChange={(e) => handleChange(e, setAddressData)} required />
                            </S.InputGroup>
                            <S.InputGroup>
                                <label>Cidade*</label>
                                <input name="city" value={addressData.city} onChange={(e) => handleChange(e, setAddressData)} required />
                            </S.InputGroup>
                            <S.InputGroup>
                                <label>Estado*</label>
                                <input name="state" value={addressData.state} onChange={(e) => handleChange(e, setAddressData)} required />
                            </S.InputGroup>
                        </S.FormGrid>
                    </>

                    {!showBank ? (
                        <S.OptionalButton type="button" onClick={() => setShowBank(true)}><FaUniversity/> Adicionar Conta Bancária (Opcional)</S.OptionalButton>
                    ) : (
                         <>
                            <h4>Dados Bancários</h4>
                            <S.FormGrid>
                                 <S.InputGroup><label>Beneficiário</label><input name="beneficiary" value={bankData.beneficiary} onChange={e => handleChange(e, setBankData)}/></S.InputGroup>
                                 <S.InputGroup><label>Banco</label><input name="bank" value={bankData.bank} onChange={e => handleChange(e, setBankData)}/></S.InputGroup>
                                 <S.InputGroup><label>Agência</label><input name="agencyNumber" value={bankData.agencyNumber} onChange={e => handleChange(e, setBankData)}/></S.InputGroup>
                                 <S.InputGroup><label>Conta</label><input name="accountNumber" value={bankData.accountNumber} onChange={e => handleChange(e, setBankData)}/></S.InputGroup>
                                 <S.InputGroup><label>Tipo de Conta</label><input name="accountType" value={bankData.accountType} onChange={e => handleChange(e, setBankData)}/></S.InputGroup>
                                 <S.InputGroup><label>Chave Pix</label><input name="pixKey" value={bankData.pixKey} onChange={e => handleChange(e, setBankData)}/></S.InputGroup>
                            </S.FormGrid>
                        </>
                    )}
                    
                    <S.Footer>
                        {error && <S.ErrorMessage>{error}</S.ErrorMessage>}
                        {success && <S.SuccessMessage>{success}</S.SuccessMessage>}
                        <S.SubmitButton type="submit" disabled={isLoading}>
                            {isLoading ? 'Cadastrando...' : 'Cadastrar Cliente'}
                        </S.SubmitButton>
                    </S.Footer>
                </S.Form>
            </S.ModalContent>
        </S.ModalBackdrop>
    );
}